export default {
  kb: {
    articles: [],
    hasMore: false,
    scrollId: undefined,
    total: 0
  },
  kbTyping: false,
  kbSearchLoader: true,
  kbSearchResult: 0,
  currentArticle: null,
  isCurrentArticleLoading: false
}
